import React, { createContext, useContext, useState } from 'react';

const ExamContext = createContext();

export const useExamContext = () => {
  const context = useContext(ExamContext);
  if (!context) {
    throw new Error('useExamContext must be used within ExamProvider');
  }
  return context;
};

export const ExamProvider = ({ children }) => {
  const [hideSidebar, setHideSidebar] = useState(false);

  return (
    <ExamContext.Provider value={{ hideSidebar, setHideSidebar }}>
      {children}
    </ExamContext.Provider>
  );
};



